export const siteName = "Wild Fork Foods";
export const titleTail = ` - ${siteName}`; // eg. if the meta title tag is "Account" => then the full title with tail would read "Account - ${siteName}"
